module.exports = __webpack_public_path__ + "img/discord-logo.2ae4b468.png";